export function CarbonLogo() {
  return (
    <span className="carbon-logo">
      <span className="carbon-mark" />
      <span className="carbon-wordmark">
        <span className="tutt">Tuttify</span>
        <span className="name">Carbon</span>
      </span>
    </span>
  )
}
